var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBothEdges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 44,
    viewBox: "0 0 227 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ysr5ht585a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.016 37a1 1 0 0 1-1-1V6h2v30a1 1 0 0 1-1 1zM43 37V6h2v31z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94 28.06a1.5 1.5 0 0 0 2.12 0l9.547-9.545a1.5 1.5 0 1 0-2.122-2.122L44 24.88l-8.485-8.486a1.5 1.5 0 1 0-2.122 2.122l9.546 9.546zM42.5 24v3h3v-3h-3z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6a1 1 0 0 1 1-1h33a1 1 0 0 1 1 1H10zM77 6a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1H77zM143 6a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1h-34zM209 6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1h-28zM43 37h36a1 1 0 0 1-1 1H44a1 1 0 0 1-1-1zM109 37h36a1 1 0 0 1-1 1h-34a1 1 0 0 1-1-1zM175 37h36a1 1 0 0 1-1 1h-34a1 1 0 0 1-1-1z",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M77.016 37V6h2v31zM109 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.939 28.06a1.501 1.501 0 0 0 2.122 0l9.546-9.545a1.501 1.501 0 0 0-2.122-2.122L110 24.88l-8.485-8.486a1.5 1.5 0 0 0-2.122 2.122l9.546 9.546zM108.5 24v3h3v-3h-3zM143.016 37V6h2v31zM175 37V6h2v31z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.939 28.06a1.501 1.501 0 0 0 2.122 0l9.546-9.545a1.501 1.501 0 0 0-2.122-2.122L176 24.88l-8.485-8.486a1.5 1.5 0 0 0-2.122 2.122l9.546 9.546zM174.5 24v3h3v-3h-3zM209.016 37V6h2v31zM12.076 14.94a1.5 1.5 0 0 0-2.121 0L.409 24.484a1.5 1.5 0 1 0 2.121 2.122l8.486-8.486 8.485 8.486a1.5 1.5 0 1 0 2.121-2.122l-9.546-9.546zM9.516 16v3h3v-3h-3zM79.076 14.94a1.5 1.5 0 0 0-2.121 0l-9.546 9.545a1.5 1.5 0 1 0 2.121 2.122l8.486-8.486 8.485 8.486a1.5 1.5 0 1 0 2.121-2.122l-9.546-9.546zM76.516 16v3h3v-3h-3zM145.076 14.94a1.5 1.5 0 0 0-2.121 0l-9.546 9.545a1.5 1.5 0 1 0 2.121 2.122l8.486-8.486 8.485 8.486a1.5 1.5 0 1 0 2.121-2.122l-9.546-9.546zm-2.56 1.06v3h3v-3h-3z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.076 14.94a1.5 1.5 0 0 0-2.121 0l-9.546 9.545a1.5 1.5 0 1 0 2.121 2.122l8.486-8.486 8.485 8.486a1.5 1.5 0 1 0 2.121-2.122l-9.546-9.546zm-2.56 1.06v3h3v-3h-3z",
    fill: "#1E7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ysr5ht585a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h227v44H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBothEdges);
export default __webpack_public_path__ + "static/media/both-edges.e0f1120d.svg";
export { ForwardRef as ReactComponent };